import React, { Component } from 'react';
import {Button} from 'rsuite';
import VideoModal from './videoModal';
const hstyle={
    fontSize: "25px",
    textAlign:"left",
    paddingTop:"20px",
    paddingBottom: "20px",
    paddingRight: "200px",
    color:"white"
}
const myTime =()=>{
    var date = new Date();
    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    var day = date.getDate();
    if (month < 10) {
    month = "0" + month;
    }
    if (day < 10) {
    day = "0" + day;
    }
    var nowDate = year + "-" + month + "-" + day;
    return nowDate;
}
const ncwu = {
    name:"华北水利水电大学",
    insi:"地球科学与工程学院"
    //time: myTime()
}
const cdut = {
    name:"成都理工大学",
    insi:"地球物理学院"
    //time: myTime()
}

class Flame extends Component {
    constructor(props){
        super(props);
        this.state={
            start:false
        }
        this.handleClick=this.handleClick.bind(this);
    }
    handleClick(){
        this.setState({
            start:true,
            showvideo:false,
        });
        if(this.props.startScene){
            this.props.startScene(this.state.start);
        }
    }
    videoopen=()=>{
        this.setState({ 
          showvideo: true ,
        });
    }
    videoclose=()=>{
        this.setState({ showvideo: false });
    }
    render(){
        const schoolA = ncwu;
        const schoolB = cdut;
        return(
            <div id="welcome">
                <span>
                    <h1 style={{ marginBottom: "20px" ,color:"white" }}>高密度电法<br/>工程模拟系统</h1>
                    <div style={{display:'flex', flexDirection:'row', alignItems:'start', gap:'40px'}}>
                        <div style={hstyle}>
                            {schoolA.name}<br />
                            <span style={{fontSize:'18px'}}>{schoolA.insi}</span>
                        </div>
                        <div style={hstyle}>
                            {schoolB.name}<br />
                            <span style={{fontSize:'18px'}}>{schoolB.insi}</span>
                        </div>
                    </div>
                    <span style={hstyle}>{myTime()}<br /></span>
                <Button appearance="primary" 
                        style={{padding:"10px",marginTop:"30px"}}
                        onClick={this.handleClick}>开始工程</Button>

                <Button  
                        style={{padding:"10px",marginTop:"30px",marginLeft:"10px"}}
                        onClick={this.videoopen}>视频说明</Button>
                </span>
                <VideoModal
                    showvideo={this.state.showvideo} 
                    videoclose = {this.videoclose}
                />
            </div>
        );
    }
}

export default Flame;